import { gql } from '@apollo/client'

import { BLOCKS } from './fragments/BLOCKS.gql';
import { HEAD_META } from './fragments/HEAD_META';
import { IMAGES } from './fragments/IMAGES'
import { LANGUAGE_SWITCH } from './fragments/LANGUAGE_SWITCH.gql';
import { NAVIGATION } from './fragments/NAVIGATION.gql';

export const PAGE_QUERY = gql`
  ${BLOCKS}
  ${LANGUAGE_SWITCH}
  ${NAVIGATION}
  query ($siteHandle: [String], $uri: [String]) {
    entry(section: "page", site: $siteHandle, uri: $uri) {
      ${HEAD_META()}
      url
      typeHandle
      title
      ... on halfImage_Entry {
        image {
          ${IMAGES('pageHalfImage')}
        }
        subTitle
        headerText
        linkTitle
        ctaUrl {
          type
          url
        }
        linkTitle2
        ctaUrl2 {
          type
          url
        }
        blocks {
          ...blocks
        }
      }
      ... on fullImage_Entry {
        image {
          ${IMAGES('pageFullImage')}
        }
        subTitle
        linkTitle
        ctaUrl {
          type
          url
        }
        linkTitle2
        ctaUrl2 {
          type
          url
        }
        blocks {
          ...blocks
        }
      }
      ... on twoColumn_Entry {
        image {
          ${IMAGES('pageTwoColumnImage')}
        }
        headerText
        linkTitle
        ctaUrl {
          type
          url
        }
        linkTitle2
        ctaUrl2 {
          type
          url
        }
        blocks {
          ...blocks
        }
      }
      ... on basic_Entry {
        title
        subTitle
        linkTitle
        ctaUrl {
          type
          url
        }
        blocks {
          ...blocks
        }
      }
      languageSwitch {
        ...languageSwitch
      }
    }
    globalSet(site: $siteHandle, handle: "navigation") {
      ...navigation
    }
  }
`;
